module.exports = "/assets/data/2e5a090ffad17ae20840ae1c5e9ec8b8-OX20.data.json";